// ЭЦП (esi.uz) orqali avtorizatsiya. redirect_uri esi.uz da ro'yxatdan o'tgan bosh sahifa;
// qaytganda kirish va ro'yxatdan o'tish state orqali ajratiladi (HomeLand.js)
const ESI_AUTHORIZE = "https://esi.uz/oauth2/authorize";
const ESI_CLIENT_ID = "091544BAEF926D20";
const ESI_REDIRECT_URI = "https://nefrit.vetgov.uz";

export const EDS_LOGIN_STATE = "login";

export function edsLoginUrl() {
  const state = encodeURIComponent(JSON.stringify({ custom: EDS_LOGIN_STATE }));
  return `${ESI_AUTHORIZE}?client_id=${ESI_CLIENT_ID}&scope=public-info+certificate-info&response_type=code&state=${state}&redirect_uri=${ESI_REDIRECT_URI}`;
}

export function isEdsLoginState(state) {
  try {
    return JSON.parse(state || "{}").custom === EDS_LOGIN_STATE;
  } catch (e) {
    return false;
  }
}
